import React, { useRef, useState, useEffect } from 'react';
// components
import ImgUpload from './ImgUpload';
import ModalConfirmImg from './ModalConfirmImg';
// ui
import Icon from '@material-ui/core/Icon';

const SimpleImage = ({ el, outputsEl, index, callbackFromParent }) => {
    // state
    const [isOpenModal, setIsOpenModal] = useState(false);

    // 이미지 업로드 모달 위치 잡으려고 넘겨줌
    const imgNode = useRef();

    // 모달
    const modalNode = useRef();
    // 모달 닫기
    const closeSet = e => {
        if (modalNode.current.contains(e.target)) {
            // inside click
            return;
        }
        setIsOpenModal(false);
    };
    // 모달 닫기
    useEffect(() => {
        // add when mounted
        document.addEventListener('mousedown', closeSet);
        // return function to be called when unmounted
        return () => {
            document.removeEventListener('mousedown', closeSet);
        };
    }, []);

    // 아이템 추가시 확인 모달
    const onClickAdd = e => {
        setIsOpenModal(true);
    };
    const callBackConfirmAction = action => {
        if (action === 'submit') {
            // 아이템 추가
            // change carousel
            let imgCardObj = {
                carousel: {
                    type: 'imageCard',
                    items: [
                        {
                            thumbnail: {
                                imageUrl: outputsEl.simpleImage.imageUrl
                            }
                        },
                        {
                            thumbnail: {
                                imageUrl: ''
                            }
                        }
                    ]
                },
                index: index
            };
            callbackFromParent(imgCardObj);
        } else {
            setIsOpenModal(false);
        }
    };

    return (
        <>
            <div className="item-cont">
                <div className="item img" ref={imgNode}>
                    <ImgUpload
                        outputsEl={outputsEl}
                        index={index}
                        callbackFromParent={callbackFromParent}
                        node={imgNode}
                        el={el}
                    />
                </div>
            </div>
            <div className="item-cont">
                <div className="item add">
                    <button type="button" onClick={onClickAdd}>
                        <Icon>add_circle_outline</Icon>
                    </button>
                </div>
            </div>
            <div ref={modalNode}>
                {isOpenModal && (
                    <ModalConfirmImg
                        callBackConfirmAction={callBackConfirmAction}
                    />
                )}
            </div>
        </>
    );
};

export default SimpleImage;
